import React from 'react';
import AdminSiteAboutPageFields from './AdminSiteAboutPageFields';
import AdminSiteHeroActionsFields from './AdminSiteHeroActionsFields';

function Field({ id, label, value, onChange, multiline, hint }) {
  return (
    <div className="col-12">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      {multiline ? (
        <textarea
          id={id}
          className="form-control"
          rows={typeof multiline === 'number' ? multiline : 3}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input id={id} className="form-control" value={value} onChange={(e) => onChange(e.target.value)} />
      )}
      {hint ? <Hint>{hint}</Hint> : null}
    </div>
  );
}

function Hint({ children }) {
  return <div className="form-text">{children}</div>;
}

export default function AdminSiteContentFields({ form, setField }) {
  return (
    <>
      <div className="card border shadow-sm mb-3">
        <div className="card-header py-2">
          <h2 className="h6 mb-0">Home page hero</h2>
          <p className="small text-muted mb-0 mt-1">Headline and hero buttons for Home, Shop, and About.</p>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <Field id="hero-title" label="Headline" value={form.hero_title} onChange={(v) => setField('hero_title', v)} />
            <Field
              id="hero-subtitle"
              label="Subtitle"
              value={form.hero_subtitle}
              onChange={(v) => setField('hero_subtitle', v)}
            />
            <Field
              id="hero-description"
              label="Description"
              value={form.hero_description}
              onChange={(v) => setField('hero_description', v)}
              multiline={3}
            />
          </div>
        </div>
      </div>

      <AdminSiteHeroActionsFields form={form} setField={setField} />

      <div className="card border shadow-sm mb-3">
        <div className="card-header py-2">
          <h2 className="h6 mb-0">Home page — Our story strip</h2>
        </div>
        <div className="card-body row g-3">
          <Field
            id="home-about-title"
            label="Section title"
            value={form.home_about_title}
            onChange={(v) => setField('home_about_title', v)}
          />
          <Field
            id="home-about-text"
            label="Body text"
            value={form.home_about_text}
            onChange={(v) => setField('home_about_text', v)}
            multiline={4}
          />
          <Field
            id="home-about-tagline"
            label="Tagline (handwritten style)"
            value={form.home_about_tagline}
            onChange={(v) => setField('home_about_tagline', v)}
          />
        </div>
      </div>

      <div className="card border shadow-sm mb-3">
        <div className="card-header py-2">
          <h2 className="h6 mb-0">About page — hero & story</h2>
        </div>
        <div className="card-body row g-3">
          <Field
            id="about-hero-title"
            label="Page title"
            value={form.about_hero_title}
            onChange={(v) => setField('about_hero_title', v)}
          />
          <Field
            id="about-hero-subtitle"
            label="Subtitle under title"
            value={form.about_hero_subtitle}
            onChange={(v) => setField('about_hero_subtitle', v)}
          />
          <Field
            id="about-para1"
            label="Paragraph 1"
            value={form.about_para1}
            onChange={(v) => setField('about_para1', v)}
            multiline={4}
          />
          <Field
            id="about-para2"
            label="Paragraph 2"
            value={form.about_para2}
            onChange={(v) => setField('about_para2', v)}
            multiline={4}
          />
          <Field
            id="about-para3"
            label="Paragraph 3"
            value={form.about_para3}
            onChange={(v) => setField('about_para3', v)}
            multiline={4}
          />
          <Field
            id="about-tagline"
            label="Closing tagline"
            value={form.about_tagline}
            onChange={(v) => setField('about_tagline', v)}
          />
        </div>
      </div>

      <AdminSiteAboutPageFields form={form} setField={setField} />
    </>
  );
}
